import React, { PureComponent } from 'react';
import Link from '@src/components/link';
import Services from '@src/services/general';
import Toast from '@src/components/toast';
import lockAsync from '@src/utils/lock-async';
import { autobind } from 'core-decorators';

import { dispatchCustomEvent, listenCustomEvent } from '@src/utils/custom-event';
import cx from 'classnames';
import reload from '@src/utils/reload';

const styles = require('./index.less');

export default class AccountInfo extends PureComponent {
  static Events = { LoginStatus: 'accountInfo:login-status', Login: 1, Logout: -1 };

  /**
   * 监听登录状态, 当登录状态因 AccountInfo 发生变化时将触发回调
   * @param {Function} callback - 回调方法
   * @example
   * 基本用法:
   *
   * AccountInfo.subscribeLoginStatus(({ status }) => {
   *
   * this.destroyAccountInfoListener = AccountInfo.subscribeLoginStatus(({ status }) => {
   *   if (status === AccountInfo.Events.Login) {
   *     alert('登录成功');
   *   } else {
   *     alert('退出成功');
   *   }
   * });
   *
   * ...
   *
   * componentWillUnmount() {
   *   this.destroyAccountInfoListener();
   * }
   *
   * @returns {Function}
   */
  static subscribeLoginStatus(callback) {
    return listenCustomEvent(AccountInfo.Events.LoginStatus, callback);
  }

  /**
   * 发送登录状态变更事件
   * @private
   * @param status
   */
  static emitLoginStatus(status) {
    dispatchCustomEvent({ eventName: AccountInfo.Events.LoginStatus, payload: { status } });
  }

  @autobind
  @lockAsync()
  async logout() {
    const { onBeforeLogoutSuccess, makeLogoutRequest, onLogoutSuccess, onLogoutClick } = this.props;
    try {
      // await makeLogoutRequest();
      await onLogoutClick();
      // AccountInfo.emitLoginStatus(AccountInfo.Events.Logout);
      // await onBeforeLogoutSuccess();
      // await onLogoutSuccess();
    } catch (e) {
      alert(e.message);
      // Toast.fail(e.message);
    }
  }

  /**
   * 渲染登出链接
   * @returns {null|ReactDOM}
   */
  renderLogoutLink() {
    const { isAllowLogout } = this.props;
    if (isAllowLogout) {
      return (
        <Link className={styles.logout} onClick={this.logout}>
          【退出】
        </Link>
      );
    }
    return null;
  }

  /**
   * 创建文本掩码
   * @param {string} text - 文本
   */
  createTextMask(text = '') {
    const textLength = text.length;
    const accountArr = text.substring(3, textLength - 3);
    return text.replace(accountArr, '******');
  }

  /**
   * 触发登录事件
   */
  @autobind
  @lockAsync()
  onLogin() {
    const { onLoginSuccess, onLoginClick } = this.props;
    onLoginClick && onLoginClick();
    // const { close } = LoginModal.append(
    //   {
    //     onLoginSuccess({ account: username, res }) {
    //       // noinspection JSIgnoredPromiseFromCall
    //       close();
    //       AccountInfo.emitLoginStatus(AccountInfo.Events.Login);
    //       onLoginSuccess(username, res);
    //     }
    //   },
    //   this
    // );
  }

  isLogin() {
    return !!this.props.username;
  }

  render() {
    let { username, isUsingMaskToUsername, renderDisplayUsername, renderLoginDisplayContent, className, style } = this.props;
    if (this.isLogin()) {
      /**
       * 计算后获取最终用于展示的 username
       */
      const displayUsername = isUsingMaskToUsername ? this.createTextMask(username) : username;
      return (
        <div className={cx(styles.textRoot, className)} style={style}>
          <div className={styles.displayName}>{renderDisplayUsername(displayUsername, this)}</div>
          <div className={styles.inlineText}>{this.renderLogoutLink()}</div>
        </div>
      );
    }
    return (
      <div className={cx(styles.textRoot, className)} style={style}>
        {renderLoginDisplayContent(this.onLogin)}
      </div>
    );
  }
}

const noop = f => f;

AccountInfo.defaultProps = {
  isUsingMaskToUsername: true,
  usernameMaskSymbol: '*',
  renderDisplayUsername(displayUsername) {
    return <React.Fragment>您好，{displayUsername}</React.Fragment>;
  },
  renderLoginDisplayContent(onLogin) {
    return (
      <React.Fragment>
        <div className={styles.displayName}>您好,请</div>
        <Link className={styles.login} onClick={onLogin}>
          【登录】
        </Link>
      </React.Fragment>
    );
  },
  makeLogoutRequest() {
    return Services.logout();
  },
  onBeforeLogoutSuccess() {},
  isAllowLogout: true,
  onLoginSuccess: noop,
  onLogoutSuccess: noop
};



// WEBPACK FOOTER //
// ./src/components/account-info/index.js